module.exports = __webpack_public_path__ + "img/email-signature-icon.7712339d.svg";